'use client';
import { useEffect, useState } from 'react';
import { usePriceConvert } from '@/lib/PriceContext';
import { t as tFn } from '@/lib/i18n';

interface Props { releaseAt: string; }

function calcTime(releaseAt: string) {
  const diff = new Date(releaseAt).getTime() - Date.now();
  if (diff <= 0) return { d: 0, h: 0, m: 0, s: 0, over: true };
  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);
  return { d, h, m, s, over: false };
}

export function CountdownClient({ releaseAt }: Props) {
  const [time, setTime] = useState(() => calcTime(releaseAt));
  const { lang } = usePriceConvert();

  useEffect(() => {
    const id = setInterval(() => setTime(calcTime(releaseAt)), 1000);
    return () => clearInterval(id);
  }, [releaseAt]);

  if (time.over) return <span className="po-countdown-over">{tFn('cd_released', lang)}</span>;
  const pad = (n: number) => String(n).padStart(2, '0');
  return (
    <div className="po-countdown">
      <div className="po-cd-block"><span className="po-cd-num" suppressHydrationWarning>{time.d}</span><span className="po-cd-label">{tFn('cd_days', lang)}</span></div>
      <span className="po-cd-sep">:</span>
      <div className="po-cd-block"><span className="po-cd-num" suppressHydrationWarning>{pad(time.h)}</span><span className="po-cd-label">{tFn('cd_hours', lang)}</span></div>
      <span className="po-cd-sep">:</span>
      <div className="po-cd-block"><span className="po-cd-num" suppressHydrationWarning>{pad(time.m)}</span><span className="po-cd-label">{tFn('cd_minutes', lang)}</span></div>
      <span className="po-cd-sep">:</span>
      <div className="po-cd-block"><span className="po-cd-num" suppressHydrationWarning>{pad(time.s)}</span><span className="po-cd-label">{tFn('cd_seconds', lang)}</span></div>
    </div>
  );
}
